import { createSelector } from '@ngrx/store';

import { ParameterResult } from '@models/swagger';
import { State } from './reducer';
import { selectFloorNumberState } from '../selectors';

export const getData = createSelector(selectFloorNumberState, (state: State) => state.data);

export const getError = createSelector(selectFloorNumberState, (state: State) => state.error);

export const getLoading = createSelector(selectFloorNumberState, (state: State) => state.loading);

export const mapData = <T>(fn: (data: ParameterResult) => T) =>
  createSelector(selectFloorNumberState, (state: State) => fn(state.data));
